import { render, staticRenderFns } from "./CommingSoon.vue?vue&type=template&id=e80efb4a&scoped=true&"
import script from "./CommingSoon.vue?vue&type=script&lang=js&"
export * from "./CommingSoon.vue?vue&type=script&lang=js&"
import style0 from "./CommingSoon.vue?vue&type=style&index=0&id=e80efb4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80efb4a",
  null
  
)

export default component.exports